import { render, staticRenderFns } from "./_SaverTrentBarton.vue?vue&type=template&id=f2cffac0&"
import script from "./_SaverTrentBarton.vue?vue&type=script&lang=js&"
export * from "./_SaverTrentBarton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports